import { UserTabOption } from "../Util";

export const PastUserTabOption = [
    ...UserTabOption,
    {
        label: "Past users",
    }
];
